import React from "react";

export default function TelegramWelcomeScreen({ onContinue, loading, country }) {
  const isKazakhstan = country === "KZ";
  const isUzbekistan = country === "UZ";

  const texts = {
    title: isKazakhstan ? "Добро пожаловать!" :
           isUzbekistan ? "Xush kelibsiz!" :
           "Тавтай морилно уу!",
    subtitle: isKazakhstan ? "Для лучшего опыта нам нужно:" :
              isUzbekistan ? "Eng yaxshi tajriba uchun bizga kerak:" :
              "Хамгийн сайн туршлагыг авахын тулд:",
    phone: isKazakhstan ? "Ваш номер телефона (для аккаунта)" :
           isUzbekistan ? "Telefon raqamingiz (hisob uchun)" :
           "Таны утасны дугаар (бүртгэлд)",
    notifications: isKazakhstan ? "Разрешение на уведомления" :
                   isUzbekistan ? "Bildirishnomalar uchun ruxsat" :
                   "Мэдэгдэл илгээх зөвшөөрөл",
    button: isKazakhstan ? "Продолжить" :
            isUzbekistan ? "Davom etish" :
            "Үргэлжлүүлэх"
  };

  return (
    <div className="bg-gray-50 min-h-screen flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-md">
        <div className="bg-[#000] p-6 text-white text-center">
          <h1 className="text-2xl font-bold">{texts.title}</h1>
        </div>
        <div className="p-6">
          <p className="text-gray-600 text-center mb-6">{texts.subtitle}</p>

          <div className="space-y-4 mb-8">
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-xl">🔔</span>
              </div>
              <span className="text-gray-700">{texts.notifications}</span>
            </div>

            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-xl">📱</span>
              </div>
              <span className="text-gray-700">{texts.phone}</span>
            </div>
          </div>

          <button
            onClick={onContinue}
            disabled={loading}
            className="w-full bg-[#000] hover:bg-opacity-80 text-white font-medium py-3 px-4 rounded-lg transition duration-300 disabled:opacity-50"
          >
            {loading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5"></div>
                <span>{texts.button}...</span>
              </div>
            ) : (
              texts.button
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
